/**
 * AppGuide Service
 * Handles the display of the App Guide Screen
 */
const AppGuide = {
    open: function () {
        // Ensure UI exists
        if (!document.getElementById('guideScreen')) {
            this.createGuideDOM();
        }

        // Stop any playing audio
        if (window.stopAudio) window.stopAudio();

        // Hide all screens
        document.querySelectorAll('.screen').forEach(s => {
            s.classList.add('hidden');
            s.classList.remove('active');
        });

        // Show Guide Screen
        const guideScreen = document.getElementById('guideScreen');
        if (guideScreen) {
            guideScreen.classList.remove('hidden');
            guideScreen.classList.add('active');

            if (window.SoundService) window.SoundService.playClick();

            // Hide Global Exit Button for this screen
            const exitBtn = document.getElementById('exitBtnGlobal');
            if (exitBtn) exitBtn.classList.add('hidden');
            const homeBtn = document.getElementById('homeBtnGlobal');
            if (homeBtn) homeBtn.classList.add('hidden');
            const backBtn = document.getElementById('backBtnGlobal');
            if (backBtn) backBtn.classList.add('hidden');

            // Internal Animation
            if (window.gsap) {
                gsap.from(".guide-section-premium", {
                    opacity: 0,
                    x: (i) => i % 2 === 0 ? -50 : 50,
                    duration: 0.8,
                    stagger: 0.2,
                    ease: "power2.out"
                });
            }
        }
    },

    createGuideDOM: function () {
        const guideDiv = document.createElement('div');
        guideDiv.id = 'guideScreen';
        guideDiv.className = 'screen hidden';

        guideDiv.innerHTML = `
            <style>
                .btn-fun-info {
                    background: linear-gradient(135deg, #6366f1, #4f46e5);
                    color: white;
                    border: 2px solid #312e81;
                    border-radius: 20px;
                    padding: 8px 16px;
                    font-weight: 800;
                    box-shadow: 0 4px 0 #312e81;
                    transition: all 0.2s;
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                    font-size: 0.9rem;
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                }
                .btn-fun-info:hover {
                    transform: translateY(2px);
                    box-shadow: 0 2px 0 #312e81;
                    background: linear-gradient(135deg, #818cf8, #6366f1);
                    color: #fff;
                }
                
                /* Modal Styles */
                .detective-modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.7);
                    backdrop-filter: blur(5px);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 10000;
                    opacity: 0;
                    pointer-events: none;
                    transition: opacity 0.3s;
                }
                .detective-modal-overlay.active {
                    opacity: 1;
                    pointer-events: all;
                }
                .detective-modal-content {
                    display: flex;
                    align-items: flex-end;
                    max-width: 800px;
                    width: 90%;
                    transform: scale(0.8);
                    transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
                .detective-modal-overlay.active .detective-modal-content {
                    transform: scale(1);
                }
                .detective-character-img {
                    height: 280px;
                    filter: drop-shadow(5px 5px 15px rgba(0,0,0,0.5));
                    margin-right: -30px;
                    z-index: 2;
                    position: relative;
                    /* Animation for character */
                    animation: floatCharacter 3s ease-in-out infinite;
                }
                @keyframes floatCharacter {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                .detective-bubble {
                    background: white;
                    border-radius: 30px;
                    padding: 2rem;
                    position: relative;
                    box-shadow: 0 10px 25px rgba(0,0,0,0.4);
                    border: 4px solid #0f172a;
                    flex: 1;
                    z-index: 1;
                }
                /* Speech bubble triangle */
                .detective-bubble::before {
                    content: '';
                    position: absolute;
                    left: -20px;
                    bottom: 80px;
                    border-top: 20px solid transparent;
                    border-bottom: 20px solid transparent;
                    border-right: 25px solid white;
                }
                 .detective-bubble::after {
                    content: '';
                    position: absolute;
                    left: -26px;
                    bottom: 80px;
                    border-top: 20px solid transparent;
                    border-bottom: 20px solid transparent;
                    border-right: 25px solid #0f172a;
                    z-index: -1;
                }

                .detective-title {
                    color: #4338ca;
                    font-weight: 900;
                    margin-top: 0;
                    font-size: 1.6rem;
                    text-transform: uppercase;
                    margin-bottom: 1rem;
                    border-bottom: 3px dashed #cbd5e1;
                    padding-bottom: 0.5rem;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                }
                
                .detective-message {
                    font-size: 1.15rem;
                    color: #334155;
                    line-height: 1.6;
                }
                .detective-message ul {
                    list-style: none;
                    padding: 0;
                    margin: 1rem 0;
                }
                .detective-message li {
                    margin: 0.8rem 0;
                    padding: 0.8rem 1rem;
                    background: #f1f5f9;
                    border-radius: 12px;
                    border-left: 5px solid #4338ca;
                }
                .detective-message strong {
                    color: #1e293b;
                }

                .btn-detective-action {
                    background: #f59e0b;
                    color: #000;
                    border: 3px solid #000;
                    padding: 12px 30px;
                    font-size: 1.2rem;
                    font-weight: 900;
                    border-radius: 50px;
                    cursor: pointer;
                    display: block;
                    margin: 1.5rem auto 0;
                    transition: transform 0.2s, background 0.2s;
                    box-shadow: 4px 4px 0 #000;
                    text-transform: uppercase;
                }
                .btn-detective-action:hover {
                    transform: scale(1.05);
                    background: #fbbf24;
                }
                .btn-detective-action:active {
                    transform: scale(0.95);
                    box-shadow: 2px 2px 0 #000;
                }

                @media (max-width: 768px) {
                    .detective-modal-content {
                        flex-direction: column;
                        align-items: center;
                    }
                    .detective-character-img {
                        height: 140px;
                        margin-right: 0;
                        margin-bottom: -20px;
                    }
                    .detective-bubble::before, .detective-bubble::after {
                        display: none; /* Hide arrow on mobile */
                    }
                    .detective-bubble {
                        width: 100%;
                        border-radius: 20px;
                    }
                }
            </style>
            <div class="container" style="max-width: 900px;">
                <header class="header" style="display: flex; justify-content: space-between; align-items: center; padding: 0 1rem; margin-bottom: 1rem;">
                    <button class="btn btn-secondary" onclick="AppGuide.close()">VOLVER ↩️</button>
                    <h1 class="main-title high-contrast guide-title" onclick="window.speak(this.innerText, 'es-ES')" style="margin: 0; text-shadow: 3px 3px 0px #000; color: #fbbf24; transform: rotate(-1deg); display: inline-block; font-size: 2rem; cursor: pointer;">🕵️ EXPEDIENTES SECRETOS <span class="btn-audio-icon" style="font-size: 0.6em; vertical-align: middle; opacity: 0.8;">🔊</span></h1>
                    <div style="width: 100px;"></div> <!-- Spacer to balance header since Exit is removed -->
                </header>
                <div class="guide-scroll-container" style="margin-top: 1rem;">
                    <!-- Sección MAPA -->
                    <section class="guide-section-premium">
                        <img src="img/guide/adventure.png" alt="Aventura" class="guide-illustration-new">
                        <div class="guide-text-content">
                            <h3 class="no-audio">
                                🗺️ ¿Cómo avanzar en el Mapa?
                                <button class="btn-audio-inline" onclick="window.toggleAudio(this, '¿Cómo avanzar en el Mapa? Cada isla es un mundo nuevo. Para avanzar, debes completar todos los problemas de la zona. ¡Gana XP para subir de nivel y desbloquear el viaje a la siguiente isla! Empieza como Aprendiz y conviértete en Experto.')"><span>🔊</span></button>
                            </h3>
                            <p>Cada isla es un mundo nuevo. Para avanzar, debes completar todos los problemas de la zona.
                                ¡Gana XP para subir de nivel y desbloquear el viaje a la siguiente isla!
                                Empieza como <strong>Aprendiz</strong> y conviértete en <strong>Experto</strong>.
                            </p>
                            <button class="btn btn-fun-info no-audio" onclick="AppGuide.showAdvanceInfo()" style="margin-top: 15px;">
                                <span>🔍</span> MÁS INFORMACIÓN
                            </button>
                        </div>
                    </section>

                    <!-- Sección PUNTOS -->
                    <section class="guide-section-premium reverse">
                        <img src="img/guide/welcome.png" alt="Puntos" class="guide-illustration-new">
                        <div class="guide-text-content">
                            <h3 class="no-audio">
                                🌟 ¡Consigue Puntos y Estrellas!
                                <button class="btn-audio-inline" onclick="window.toggleAudio(this, '¡Consigue Puntos y Estrellas! Cada vez que resuelves un problema correctamente, ganas XP (Puntos de Experiencia) para subir de nivel y Estrellas doradas.')"><span>🔊</span></button>
                            </h3>
                            <p>Cada vez que resuelves un problema correctamente, ganas <strong>XP (Puntos de
                                    Experiencia)</strong> para subir de nivel y <strong>Estrellas</strong> doradas.</p>
                             <button class="btn btn-fun-info no-audio" onclick="AppGuide.showPointsInfo()" style="margin-top: 15px;">
                                <span>⭐</span> MÁS INFORMACIÓN
                             </button>
                        </div>
                    </section>

                    <!-- Sección TIENDA -->
                    <section class="guide-section-premium">
                        <img src="img/guide/store.png" alt="Tienda" class="guide-illustration-new">
                        <div class="guide-text-content">
                            <h3 class="no-audio">
                                🏪 La Tienda de Accesorios
                                <button class="btn-audio-inline" onclick="window.toggleAudio(this, 'La Tienda de Accesorios. Ve a la Tienda y usa tus estrellas para comprar sombreros, gafas y skins para tu personaje. ¡Haz clic en COMPRAR para tenerlos!')"><span>🔊</span></button>
                            </h3>
                            <p>Ve a la Tienda y usa tus estrellas para comprar sombreros, gafas y skins para tu personaje.
                                ¡Haz clic en <strong>COMPRAR</strong> para tenerlos!</p>
                        </div>
                    </section>

                    <!-- Sección EQUIPAR -->
                    <section class="guide-section-premium reverse">
                        <img src="img/guide/solving.png" alt="Equipar" class="guide-illustration-new">
                        <div class="guide-text-content">
                            <h3 class="no-audio">
                                🎩 ¿Qué hacer con lo que compras?
                                <button class="btn-audio-inline" onclick="window.toggleAudio(this, '¿Qué hacer con lo que compras? ¡Se equipan automáticamente! Ahora tu detective lucirá sus nuevos accesorios en todos los problemas que resuelvas. ¡Presume tu estilo!')"><span>🔊</span></button>
                            </h3>
                            <p>¡Se equipan automáticamente! Ahora tu detective lucirá sus nuevos accesorios en todos los
                                problemas que resuelvas. ¡Presume tu estilo!</p>
                        </div>
                    </section>
                </div>


                <div style="text-align: center; margin-top: 3rem; margin-bottom: 5rem;">
                    <button class="btn btn-primary" onclick="window.showConfigScreen && window.showConfigScreen()"
                        style="padding: 1rem 4rem; font-size: 1.5rem;">¡A INVESTIGAR!</button>
                </div>
            </div>
        `;

        document.body.appendChild(guideDiv);

        // Trigger audio button enforcer for new content
        if (window.addSafeAudioButtons) window.addSafeAudioButtons();
    },

    close: function () {
        const guideScreen = document.getElementById('guideScreen');
        if (guideScreen) {
            guideScreen.classList.add('hidden');
            guideScreen.classList.remove('active');
        }

        // Stop any playing audio
        if (window.stopAudio) window.stopAudio();

        // Show Home Screen
        const homeScreen = document.getElementById('welcomeScreen');
        if (homeScreen) {
            homeScreen.classList.remove('hidden');
            homeScreen.classList.add('active');
        }
    },

    showPointsInfo: function () {
        this.showDetectiveModal(
            "🌟 ¡INFORME DE RECOMPENSAS!",
            "<p>¡Escucha bien, sabueso! 🐶 Cuando resuelves misterios, ¡te haces más fuerte!</p><ul><li>🎯 <strong>+10 XP</strong>: ¡Por cada problema resuelto!</li><li>✅ <strong>+2 XP</strong>: ¡Por cada paso correcto!</li><li>🏆 <strong>+5 XP</strong>: ¡Extra si eres PERFECTO (sin fallos)!</li><li>🔥 <strong>+15 XP</strong>: ¡Bono por volver cada día!</li></ul><p>¡Y las <strong>ESTRELLAS</strong> ⭐ son para los mejores coleccionistas! ¿Cuántas podrás conseguir?</p>",
            "¡Informe de Recompensas! ¡Escucha bien, sabueso! Cuando resuelves misterios, ¡te haces más fuerte! más 10 XP por cada problema resuelto. más 2 XP por cada paso correcto. más 5 XP si eres perfecto. más 15 XP por volver cada día. ¡Y las Estrellas son para los mejores coleccionistas!"
        );
    },

    showAdvanceInfo: function () {
        this.showDetectiveModal(
            "🗺️ CLAVES DEL VIAJE",
            "<p>¿Quieres descubrir nuevas islas? 🏝️ ¡Demuéstrame tu valía!</p><p>🚀 Tu pase de viaje es tu <strong>NIVEL DE DETECTIVE</strong>. ¡Necesitas XP para subir de nivel y desbloquear la siguiente zona!</p><p>📚 Da igual si eres Aprendiz o Maestro, ¡cada problema cuenta! ¡Resuelve, sube de nivel y VIAJA!</p>",
            "Claves del Viaje. ¿Quieres descubrir nuevas islas? ¡Demuéstrame tu valía! Tu pase de viaje es tu Nivel de Detective. ¡Necesitas XP para subir de nivel y desbloquear la siguiente zona! Da igual si eres Aprendiz o Maestro, ¡cada problema cuenta! ¡Resuelve, sube de nivel y viaja!"
        );
    },

    showDetectiveModal: function (title, message, plainTextForAudio) {
        // Remove existing modal if any
        const existing = document.getElementById('detectiveModal');
        if (existing) existing.remove();

        // Stop any playing audio before showing a new modal
        if (window.stopAudio) window.stopAudio();

        // Use the character image available in the project
        const characterImgSrc = 'img/guide/adventure.png';

        // Prepare Audio Button HTML if text provided
        let audioBtnHtml = '';
        if (plainTextForAudio) {
            // Escape single quotes for safety
            const safeText = plainTextForAudio.replace(/'/g, "\\'");
            audioBtnHtml = `<button class="btn-audio-inline" onclick="window.toggleAudio(this, '${safeText}')" style="margin-left: 10px; vertical-align: middle;"><span>🔊</span></button>`;
        }

        const modalOverlay = document.createElement('div');
        modalOverlay.id = 'detectiveModal';
        modalOverlay.className = 'detective-modal-overlay';

        modalOverlay.innerHTML = `
            <div class="detective-modal-content">
                <img src="${characterImgSrc}" alt="Detective" class="detective-character-img">
                <div class="detective-bubble">
                    <h2 class="detective-title">
                        ${title}
                        ${audioBtnHtml}
                    </h2>
                    <div class="detective-message">${message}</div>
                    <button class="btn-detective-action" onclick="AppGuide.closeDetectiveModal()">¡ENTENDIDO!</button>
                </div>
            </div>
        `;

        document.body.appendChild(modalOverlay);

        // Trigger audio button enforcer for new content logic
        if (window.addSafeAudioButtons) window.addSafeAudioButtons();

        // Add animation class after a slight delay
        requestAnimationFrame(() => {
            modalOverlay.classList.add('active');
        });

        // Add Escape key listener
        const escapeHandler = (e) => {
            if (e.key === 'Escape') AppGuide.closeDetectiveModal();
        };
        document.addEventListener('keydown', escapeHandler, { once: true });
    },

    closeDetectiveModal: function () {
        const modal = document.getElementById('detectiveModal');
        if (modal) {
            modal.classList.remove('active');

            // Stop any playing audio
            if (window.stopAudio) window.stopAudio();

            setTimeout(() => modal.remove(), 300);
        }
    }
};

window.AppGuide = AppGuide;
